export default __webpack_public_path__ + "static/media/consult.d8559617.svg";